import { apiClient } from '@/api/client';
import type {
  DismissReminderPayload,
  Paged,
  ReminderDto,
  ReminderListFilters,
  ReminderPendingCountDto,
} from '@/types/api';

/**
 * 到期提醒 API 模块（PRD-09 §6.5 / backend/routes/api.php :453-461）
 */

export const reminderApi = {
  pendingCount: () =>
    apiClient.get<unknown, ReminderPendingCountDto>('/reminders/pending-count'),

  list: (filters: ReminderListFilters = {}) =>
    apiClient.get<unknown, Paged<ReminderDto>>('/reminders', { params: filters }),

  /** 确认或忽略；已 dismissed 状态后端不报错（idempotent） */
  dismiss: (id: number, payload: DismissReminderPayload) =>
    apiClient.patch<unknown, ReminderDto>(`/reminders/${id}/dismiss`, payload),
};
